import { handleActions } from 'redux-actions'
import * as constants from './constants'

const defaultState = {
  features: null,
  isAuthenticatedFeaturesLoaded: false,
  events: null,
  eventsPending: true
}

export default handleActions(
  {
    [constants.SET_EDUCATION_FEATURES]: (state, { payload }) => ({
      ...state,
      features: payload
    }),
    [constants.SET_IS_AUTHENTICATED_FEATURES_LOADED]: (state, { payload }) => ({
      ...state,
      isAuthenticatedFeaturesLoaded: payload
    }),
    [constants.SET_EDUCATION_EVENTS]: (state, { payload }) => ({
      ...state,
      events: payload
    }),
    [constants.SET_EDUCATION_EVENTS_PENDING]: (state, { payload }) => ({
      ...state,
      eventsPending: payload
    }),
    [constants.ADD_EDUCATION_EVENT]: (state, { payload }) => ({
      ...state,
      events: state.events ? [...state.events, payload] : null
    })
  },
  defaultState
)
